<template>
    <div class="payFreight">
        <div class="topNav">
            <el-button size="mini" @click="()=> { $router.back(-1) }">返回</el-button>
            <span v-has="'06020022'">
                <el-button size="mini" class="el-button el-button--primary margin-left" @click="save">提交</el-button>
            </span>
        </div>
        <div class="payFreight-cont-box">
            <div class="content">
                <div style="width:100%;">
                    <div><span class="content-title">{{headInfo.bidName}}</span><span class="content-label">{{headInfo.costStatusText}}</span></div>
                    <div class="content-desc">
                        <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{headInfo.bidNo}}</span></span>
                        <span class="content-desc-item">订单号<span class="content-desc-cont">{{headInfo.orderNo}}</span></span>
                        <span class="content-desc-item">下单时间<span class="content-desc-cont">{{headInfo.orderTime}}</span></span>
                        <span class="content-desc-item">订单类型<span class="content-desc-cont">{{headInfo.orderTypeText}}</span></span>
                        <span class="content-desc-item">缴纳方式<span class="content-desc-cont">{{headInfo.payTypeText}}</span></span>
                    </div>
                </div>
                <div class="content-right">
                    <div style="margin-right:30px;width: 108px;">
                        <div><span class="money">{{headInfo.receivePayAmount}}</span>元</div>
                        <div style="margin-top:4px;">应付金额</div>
                    </div>
                </div>
            </div>
            <div class="file-upload-wrap">
                <div class="file-upload-wrap__header">
                    <div style="margin-right: 10px;">附件文档</div>
                    <div style="display: flex;">
                        <el-button type="primary" size="small" @click="downTemp">下载模板</el-button>
                        <Upload class="upload-btn" accept=".pdf,.docx,.doc,.jpg,.png" :fileTypeReg="/\.(doc|docx|pdf|jpg|png)$/" :text="'上传附件'" :uploadDisplayType="'button'" @uploadSuccess="attachmentUpload"></Upload>
                    </div>
                </div>
                <el-table :data="attachmentList" style="width: 100%;margin-top: 10px;" border >
                    <el-table-column show-overflow-tooltip prop="fileName" label="附件名称" align="center"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="updateTime" label="上传时间" align="center"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="actionFn(scope.row, '0')">预览</el-button>
                            <el-button type="text" size="small" @click="actionFn(scope.row, '1')">下载</el-button>
                            <el-button type="text" size="small" @click="actionFn(scope.row, '2', scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="padding:10px;">
                <div class="upload_enclosure">
                    <div>未结账单据信息</div>
                </div>
                <el-form :model="formObj" ref="tabeditorInfo" :rules="formObj.rules">
                    <el-table :data="formObj.infoList" style="width: 100%" border tooltip-effect='dark' >
                        <el-table-column prop="relationOrderNo" label="未结单号" align="center"></el-table-column>
                        <el-table-column prop="companyName" label="分公司" align="center"></el-table-column>
                        <el-table-column prop="totalAmount" label="总金额" align="center"></el-table-column>
                        <el-table-column prop="availableAmount" label="可用金额" align="center"></el-table-column>
                        <el-table-column prop="inputVal" label="转投标保证金金额" align="center">
                            <template slot-scope="scope">
                                <el-form-item :prop="'infoList.' + scope.$index + '.inputVal'" :rules='formObj.rules.inputVal(scope.row)'>
                                    <el-input v-model="scope.row.inputVal" placeholder="转投标保证金金额" size="mini" type="number" @focus="handleFocus($event, scope.row)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import { getSupplierFreight, bidBid4Cost, freightTransferred } from '../../../../lsrm/api/myBidding.js';
import { filePreview } from '@/utils/filePreview.js';
import { delModuleFile } from '../../../../lsrm/api/annoMana.js';
import Upload from '../../../components/upload/Index.vue';
import { dictWithUrl } from '@/components/lots/api';
import dayjs from 'dayjs';
export default {
    name: 'payFreight',
    components: {Upload},
    data() {
        const inputValVail = row => {
            return (rule, value, callback) => {
                if (+value < 0) {
                    callback(new Error('不能小于0！'));
                } else if (+value > +row.availableAmount) {
                    callback(new Error('不能大于可用金额！'));
                } else {
                    callback();
                }
            }
        };
        return {
            formObj: {
                infoList: [],
                rules: {
                    inputVal: row => {
                        return { required: true, validator: inputValVail(row), trigger: 'blur' }
                    }
                }
            },
            headInfo: {},
            // availableAmount: '',
            dictData: [],
            currentInputEle: null,
            inputFocused: false, // 是否已经聚焦
            focusedCompanyCodes: [],
            attachmentList: [],
        };
    },
    mounted() {
        this.loadData();
    },
    activated() {
        this.focusedCompanyCodes = []
        this.attachmentList = []
    },
    watch: {
        $route(to, from) {
            if (to.path === '/lsrm/payFreight') {
                this.loadData();
            };
        }
    },
    methods: {
        downTemp(){
            dictWithUrl('SRM_TEMPLATE_COLLECTION').then(res => {
                if(res.data.SRM_TEMPLATE_COLLECTION.FREIGHT_TO_DEPOSIT){
                    window.open(res.data.SRM_TEMPLATE_COLLECTION.FREIGHT_TO_DEPOSIT, '_parent');
                }else{
                    this.$message.warning('下载失败，模板链接不存在')
                }
            });
        },
        attachmentUpload(res){
            // this.uploadData = res.data.data;
            this.attachmentList = [];
            this.attachmentList.push({
                fileName: res.data.data.localFileName,
                updateTime: dayjs(res.data.timestamp.split('.')[0]).format('YYYY-MM-DD HH:mm:ss'),
                fileUrl: res.data.data.downUrl,
                fileId: res.data.data.id
            });
        },
        delModuleFileFn(id, index) {
            delModuleFile(id).then((res) => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功！');
                    this.attachmentList.splice(index, 1);
                }
            });
        },
        actionFn(row, type, index) {
            if (type === '1') {
                window.open(row.fileUrl, '_parent');
            } else if (type === '2') {
                if (row.id) {
                    this.delModuleFileFn(row.id, index);
                } else {
                    this.$message.success('删除成功！');
                    this.attachmentList.splice(index, 1);
                }
            } else {
                filePreview(row);
            }
        },
        loadData() {
            dictWithUrl('BID_COST_STATUS').then(res => {
                this.dictData = res.data;
                this.getSupplierBond();
            });
            getSupplierFreight({
                'bidNo': this.$route.query.bidNo,
                'supplierCode': this.$route.query.supplierCode
            }).then(res => {
                if (+res.code === 0) {
                    const infoList = res.data;
                    infoList.forEach(el => {
                        el.inputVal = '';
                    });
                    this.formObj.infoList = infoList;
                }
            });
        },
        dataFormat(list) {
            list.costStatusText = this.dictData.BID_COST_STATUS[list.costStatus];
            return list;
        },
        getSupplierBond() {
            let params = {};
            if (this.$route.query.myBidFlag) {
                params = { id: this.$route.query.id, payType: this.$route.query.payType };
            } else {
                params = { costId: this.$route.query.id, payType: this.$route.query.payType };
            }
            bidBid4Cost(params).then(res => {
                if (res && +res.code === 0) {
                    this.attachmentList = res.data.bidModuleFiles || []
                    this.headInfo = this.dataFormat(res.data);
                    this.headInfo.orderTypeText = this.headInfo.orderType === '1' ? '标书费' : this.headInfo.orderType === '2' ? '投标保证金缴纳' : '投标保证金退还';
                    this.headInfo.payTypeText = this.headInfo.payType === '1' ? '线下汇款' : this.headInfo.payType === '2' ? '在线支付' : '运费转投标保证金';
                }
            });
        },
        save() {
            let allAmount = 0;
            const that = this;
            that.formObj.infoList.forEach(el => {
                allAmount += +el.inputVal;
            });
            if (allAmount === +that.headInfo.receivePayAmount) {
                that.$refs.tabeditorInfo.validate((valid) => {
                    if (valid) {
                        if(!this.attachmentList.length) {
                            return this.$message.warning('请上传附件文档')
                        }
                        const list = [];
                        that.formObj.infoList.forEach(function(item) {
                            if (item.inputVal) {
                                list.push({
                                    transferAmount: +item.inputVal,
                                    relationOrderNo: item.relationOrderNo,
                                    totalAmount: item.totalAmount,
                                    availableAmount: item.availableAmount,
                                    orderNo: that.headInfo.orderNo
                                });
                            }
                        });
                        const params = {
                            costDetails: list,
                            id: that.headInfo.id,
                            bidNo: that.headInfo.bidNo,
                            supplierCode: that.headInfo.supplierCode,
                            supplierName: that.headInfo.supplierName,
                            orderNo: that.headInfo.orderNo,
                            contactName: that.headInfo.contactName,
                            contactNumber: that.headInfo.contactNumber,
                            receivePayAmount: that.headInfo.receivePayAmount,
                            actualReceivePay: that.headInfo.actualReceivePay,
                            bidModuleFiles: this.attachmentList 
                        };
                        freightTransferred(params).then(res => {
                            if (res && +res.code === 0) {
                                that.$message.success('提交成功！');
                                that.$router.push({
                                    name: 'myBidding'
                                });
                            }
                        });
                    } else {
                        that.$message.error('请正确填写表单数据！');
                    }
                });
            } else {
                that.$message.error('转投保证金金额不等于应付金额！');
            }
        },
        // inputFn(row) {
        //     this.availableAmount = row.availableAmount;
        // },
        handleFocus(e, row) {
            try {
                // 当前供应商分公司与当前行分公司相同则不需要提示
                if (this.headInfo.companyCode === row.companyCode || this.focusedCompanyCodes.includes(row.companyCode)) {
                    return false
                }
                this.currentInputEle = e.target
                if (this.inputFocused) {
                    return false
                }
                this.inputFocused = true
                this.focusedCompanyCodes.push(row.companyCode)
                this.$confirm(`为避免后期出现复杂对账问题，建议选择招标分公司${this.headInfo.companyName}转投标保证金，你确定继续使用吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    showClose: true
                }).then(() => {
                    this.currentInputEle.focus()
                    setTimeout(() => { this.inputFocused = false }, 200)
                }).catch(e => {
                    this.currentInputEle.blur()
                    setTimeout(() => { this.inputFocused = false }, 200)
                });
            } catch (error) {
                console.log(error)
            }
        },
    }
};
</script>

<style lang="less">
.payFreight {
    margin: 0 10px;
    font-size: 12px;
    background: #fff;
    .margin-left {
        margin-left: 10px;
    }
    .payFreight-cont-box {
        overflow-y: auto;
        min-height: calc(~"100vh - 110px") !important;
        max-height: calc(~"100vh - 110px") !important;
    }
    .topNav {
        padding-left: 10px;
        width: 100%;
        height: 46px;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        box-sizing: border-box;
    }
    .content {
        margin: 10px;
        padding: 14px;
        min-width: 1400px;
        box-sizing: border-box;
        background: #F8F8F8;
        vertical-align: middle;
        display: flex;
        align-items: center;
        .content-title {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: 700;
        }
        .content-label {
            margin-left: 12px;
            padding: 3px 6px;
            border-radius: 2px;
            background: #FF7C24;
            display: inline-block;
            color: #fff;
        }
        .content-desc {
            margin-top: 15px;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
        }
        .content-desc-item {
            margin: 0 20px 4px 0;
            color: #888888;
        }
        .content-desc-cont {
            margin-left: 5px;
            color: #333333;
        }
        .content-right {
            margin-right: 30px;
            display: flex;
        }
        .money {
            font-size: 18px;
            font-weight: 700;
            color: #FF8800;
        }
    }
    .el-tabs__item {
        font-size: 12px;
    }
    .payIframe {
        width: 100%;
        height: 100%;
        border: none;
    }
    .upload_enclosure {
        margin-bottom: 10px;
        width:100%;
        display: flex;
        justify-content: space-between;
    }
    .el-form-item {
        margin-bottom: 15px;
    }
    .el-table .cell,.el-table .cell > div {
        overflow: initial;
    }
    .file-upload-wrap{
        padding: 10px;
        &__header{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .upload-btn{
            color:#00BCBF;
            margin-left: 10px;
        }
    }
}
</style>